// theme constant
export const gridSpacing = 1;
export const paperShadow = 20;
export const drawerWidth = 260;
export const appDrawerWidth = 520;
